import React from "react"
import Text from "antd/lib/typography/Text"
import { User } from "../../../user/types"

interface Props {
  user?: User
}

export const UserName = ({ user }: Props) => (
  <Text
    style={{
      textTransform: "capitalize",
    }}
  >
    {user ? user.data.name : ""}
  </Text>
)
